(() => {
  if(window.tyvokMobilePurchaseClearance)return;
  window.tyvokMobilePurchaseClearance=true;
  const root=document.documentElement;
  const mobile=matchMedia('(max-width:767px)');
  const formsSelector='.product-information form[action*="/cart/add"]:not(.installment),.p2-conversion__form,.tyvok-p2 form[action*="/cart/add"]';
  let scheduled=false;
  const visibleRect=el=>{
    const rect=el.getBoundingClientRect(),style=getComputedStyle(el);
    return rect.width>0 && rect.height>0 && rect.right>0 && rect.left<innerWidth && style.visibility!=='hidden' && style.display!=='none' ? rect : null;
  };
  const update=()=>{
    scheduled=false;
    let active=false,clearance=0;
    if(mobile.matches){
      const height=visualViewport?.height || innerHeight;
      document.querySelectorAll(formsSelector).forEach(form=>{
        const rect=visibleRect(form);
        if(rect && rect.top<height+32 && rect.bottom>0)active=true;
        form.querySelectorAll('button[type="submit"],.shopify-payment-button,.add_to_cartBox').forEach(control=>{
          let parent=control;
          for(let i=0;parent && i<6;i++,parent=parent.parentElement){
            const fixed=getComputedStyle(parent).position==='fixed',r=visibleRect(parent);
            if(fixed && r && r.height<200 && r.bottom>=height-8 && r.top>height/2)clearance=Math.max(clearance,Math.ceil(height-r.top)+12);
          }
        });
      });
      document.querySelectorAll('.p2-conversion__sticky').forEach(el=>{
        const rect=visibleRect(el);
        if(rect && rect.bottom>=height-8 && rect.top>height/2)clearance=Math.max(clearance,Math.ceil(height-rect.top)+12);
      });
    }
    root.classList.toggle('tyvok-mobile-purchase-active',active);
    const value=clearance+'px';
    if(root.style.getPropertyValue('--tyvok-mobile-sticky-clearance')!==value)root.style.setProperty('--tyvok-mobile-sticky-clearance',value);
  };
  const schedule=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(update)}};
  addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule,{passive:true});
  visualViewport?.addEventListener('resize',schedule,{passive:true});
  document.addEventListener('shopify:section:load',schedule);
  const content=document.querySelector('#main-content');
  if(content)new MutationObserver(schedule).observe(content,{childList:true,subtree:true});
  schedule();
})();
